export function htmlToReadableText(html: string) {
	const dom = new DOMParser().parseFromString(html, "text/html");

	function transformListItem(element: HTMLUListElement | HTMLOListElement) {
		const entries = element.getElementsByTagName("li");

		for (let i = 0; i < entries.length; i++) {
			const listItem = entries[i];
			const text = listItem.textContent;

			// modify the text to include the index.
			listItem.textContent = `${i + 1}. ${text}`;
		}
	}

	for (const list of [...dom.getElementsByTagName("ul"), ...dom.getElementsByTagName("ol")]) {
		transformListItem(list);
	}

	return dom.body.textContent || "";
}
